/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createProductsRepository = (options: RestApiOptions): Types.ProductsRepository => ({
    async getAll(params, requestOptions) {
        return options.request('/products/getAll', params, { method: 'post', responseType: 'json', ...requestOptions });
    },
    async getPrices(params, requestOptions) {
        return options.request('/products/getPrices', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
